import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../../../core/authentication/authentication.service';
import { take } from 'rxjs/internal/operators/take';
import { SnackbarService } from '../../../../core/services/snack.service';

@Component({
    selector: 'app-validate-user',
    templateUrl: './validate-user.component.html',
    styleUrl: './validate-user.component.scss',
    standalone: false
})
export class ValidateUserComponent implements OnInit{
  static readonly MinPasswordLength = 5;

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private authService: AuthenticationService,
    private snackbarService: SnackbarService) { }

  password: string = '';
  repeatedPassword: string = '';
  token: string = '';

  ngOnInit(): void {
    this.token = this.activeRoute.snapshot.paramMap.get('token')!.toString();
  }

  get hasMinLength(): boolean {
    return this.password.length >= ValidateUserComponent.MinPasswordLength;
  }

  get passwordsMatch(): boolean {
    return this.password.length > 0 && this.password === this.repeatedPassword;
  }

  get canSubmit(): boolean {
    return this.hasMinLength && this.passwordsMatch;
  }

  validateUser() {
    if (!this.canSubmit) {
      return;
    }

    this.authService.validateUser(this.token, this.password, this.repeatedPassword)
      .pipe(take(1)).subscribe({
        next: () => {
          this.snackbarService.showSuccess('Tu contraseña se ha actualizado correctamente.');
          this.router.navigate(['/login']);
        },
        error: () => {
          this.snackbarService.showError(
            'No se ha podido actualizar la contraseña. El enlace puede haber caducado o la contraseña no cumple los requisitos.',
          );
        },
      });
  }
}
